import { render, staticRenderFns } from "./pubtravel.vue?vue&type=template&id=6f2eab12&scoped=true&"
import script from "./pubtravel.vue?vue&type=script&lang=js&"
export * from "./pubtravel.vue?vue&type=script&lang=js&"
import style0 from "./pubtravel.vue?vue&type=style&index=0&id=6f2eab12&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2eab12",
  null
  
)

export default component.exports